<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'REPORTS'" [breadcrumb]="''" [count]="count"
    icon="fa-file-invoice">
</app-breadcrumb>
<div class="content-background">
    <div class="row">
        <div class="col-sm-12">
            <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                <app-advanced-mode id="reportGridAdvancedSwitch" [storageKey]="'reports-list'"
                    (collapsibleToggle)="enableAdvanced=$event">
                </app-advanced-mode>
                <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
                    title="{{ 'SEARCH-NOTICE' | translate }}" (keyup)="searchFieldChange(search.value)" />
                <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <kendo-grid #grid [data]="gridView" [navigable]="true"
            [pageable]="count > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="state.take"
            [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter" [sortable]="true"
            [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true"
            [reorderable]="enableAdvanced" (dataStateChange)="dataStateChange($event)">
            <kendo-grid-messages noRecords="{{ 'NO-REPORTS' | translate }}">
            </kendo-grid-messages>
            <kendo-grid-column field="name" title="{{ 'NAME' | translate }}" [width]="13">
            </kendo-grid-column>
            <kendo-grid-column field="description" title="{{ 'DESCRIPTION' | translate }}" [width]="13" [hidden]="true">
            </kendo-grid-column>
            <kendo-grid-column field="reportType" title="{{ 'TYPE' | translate }}" [width]="10" [columnMenu]="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.reportType === 'REPORT' ? reportText : metricText}}
                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-filter>
                    <app-dropdown-filter [filter]="filter" [data]="reportTypes" filterField="reportType"
                        selectDefaultText="{{ 'SELECT-TYPE' | translate }}" textField="name" valueField="value">
                    </app-dropdown-filter>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column class="text-center" field="privateReport" [width]="8" title="{{ 'PRIVATE' | translate }}"
                filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i *ngIf="dataItem.privateReport" class="fas fa-check"></i>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="createdBy" [width]="8" title="{{ 'CREATED-BY' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="createdByOrganization" [width]="15"
                title="{{ 'CREATED-BY-ORGANIZATION' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="createdOn" [width]="10" title="{{ 'CREATED-DATE' | translate }}" filter="date"
                format="{0:g}">
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedBy" [width]="8" title="{{ 'LAST-MODIFIED-BY' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedOn" [width]="10" title="{{ 'LAST-MODIFIED-DATE' | translate }}"
                filter="date" format="{0:g}">
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedByOrganization" [width]="15"
                title="{{ 'LAST-MODIFIED-BY-ORGANIZATION' | translate }}">
            </kendo-grid-column>
            <kendo-grid-command-column [width]="reportEditDisabled ? 5 : 10" title="{{ 'ACTIONS' | translate }}"
                class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="!reportEditDisabled">
                        <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}"
                            (click)="editHandler(dataItem['id'])">
                        </i>
                        &nbsp;
                        <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                            (click)="confirmHandler(dataItem['id'], 'deleteDialog')">
                        </i>
                        &nbsp;
                        <i class="fas fa-copy fa-lg" title="{{ 'COPY' | translate }}"
                            (click)="confirmHandler(dataItem['id'], 'copyDialog')">
                        </i>
                        &nbsp;
                    </span>
                    <i class="fas fa-file-excel fa-lg pointer" title="{{ 'EXPORT-TO-EXCEL' | translate }}"
                        (click)="runReport(dataItem)">
                    </i>
                </ng-template>
            </kendo-grid-command-column>
        </kendo-grid>
        <button kendoButton *ngIf="!reportEditDisabled" [primary]="false" type="button" class="float-right mt-3 mb-3"
            (click)="addHandler()">
            {{'ADD' | translate}}<i class="far fa-plus"></i>
        </button>
    </div>
</div>

<!--Add/Edit form-->
<app-report-edit [model]="editDataItem" [isNew]="isNew" (save)="saveChangesHandler($event)"
    (cancelling)="cancelChangesHandler()">
</app-report-edit>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
    [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-DELETION' | translate }}</p>
    <span class="k-font-weight-bold">{{selectedReport.name}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Copy-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="copyDialogOpened" (close)="close('copyDialog')"
    [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-COPY' | translate }}</p>
    <span class="k-font-weight-bold">{{selectedReport.name}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="copyAction(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="copyAction(true)" [primary]="true">{{ 'YES' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Report-->
<div class="k-overlay" *ngIf="reportModalOpened"></div>
<kendo-window *ngIf="reportModalOpened" class="kendo-window" [width]="1200" [height]="750" (close)="closeReport()"
    [state]="windowState" (stateChange)="onWindowStateChange($event)">
    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3 class="ellipsis-text">{{reportName}}</h3>
        </div>
        <button kendoWindowMaximizeAction></button>
        <button kendoWindowRestoreAction></button>
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <app-report-grid [reportId]="reportId" [sqlViewName]="reportViewName" [gridSettings]="reportGridSettings"
        [designMode]="false" [parentWindowState]="windowState" [reportName]="reportName">
    </app-report-grid>
</kendo-window>